import React, { useEffect, useState} from "react";

const ConfirmationPrompt = props => {
    return(
        <>
        {
            props.modalState === 'delete' && 
            <>
            <p>Are you sure you want to delete <strong>{props.sensorToDelete?.name}</strong>?</p>
            </>
        }
        {
            props.modalState === 'toggle' &&
            <p>
                <strong>WARNING</strong> Are you sure you want to disable <strong>{props.sensorToToggle?.name}</strong>?
            </p>
        }
        </>
    );
}

export default ConfirmationPrompt;
